/**
 * Moduł obsługujący sekcję Dodatkowego Podmiotu na formularzu dostawy
 * Zdarzenia obsługiwane przez moduł:
 * - DELIVERY_TAX_PAYER_ROLE_CHANGED - zmiana roli podatnika przez checkbox JST/GRV
 * - DELIVERY_INVOICE_DATA_CHANGED - ukrycie/pokazanie sekcji faktury przez radio "Jak moje dane (podane powyżej)" / "Inne dane do faktury"
 * - DELIVERY_FRONT_USER_TYPE_CHANGED - zmiana typu użytkownika przez radio (Firma/Osoba fizyczna)
 * - DELIVERY_OTHER_INVOICE_RECEIVER_CHANGED - zmiana checkboxa "Inny nabywca na fakturze" w sekcji "Dane do faktury"
 * - DELIVERY_INVOICE_TAX_ID_TYPE_CHANGED - zmiana typu identyfikatora podatkowego w danych do faktury
 * - DELIVERY_BUYER_TAX_ID_TYPE_CHANGED - zmiana typu identyfikatora podatkowego w sekcji "Kupuję jako"
 * - VIES_VERIFICATION_FINISHED - zakończenie weryfikacji VAT UE w VIES
 */
app.service('deliveryAdditionalEntityInvoiceDetails', function (orderClass, orderConfig, vies, regon, companyName, select, validate, broker, percentageShare) {

	let $self, $toggleAdditionalEntityDetails, $taxIdentifierSelector, $taxIdTypeBoxes, $vatUe, $nip, $idNumber, $numberIdCountryCode, $vatUeCountryCode, $countryCode,
		$companyName, $employeeName, $employeeAddressDetailsToggle, $invoiceAddress, $internalId, $roleSelector, $zipCode, $roleDescription, $percentageShare,
		$additionalEntityFormTitle, $additionalEntityAddressTitle, $additionalInvoiceDataSelector, $additionalInvoiceDataInput, $additionalInvoiceEmail;
	let config, additionalTaxIdType, role, employeeAddressRequired;
	let isOneInit = false;

	function init($deliveryForm) {
		$self = $deliveryForm.find('#additional-invoice-data');
		if (!$self.length) {
			return;
		}

		config = orderConfig.getData();

		setElements($deliveryForm);
		setEvents($deliveryForm);

		percentageShare.init($percentageShare);

		additionalTaxIdType = config.deliveryInfo.additionalInvoiceTaxIdType;
		role = config.deliveryInfo.additionalInvoiceRole;
	}

	function setElements($deliveryForm) {
		$toggleAdditionalEntityDetails = $deliveryForm.find('#toggle-additional-invoice-details');
		$taxIdTypeBoxes = $self.find('.tax-id-type-box');
		$vatUe = $self.find('#additional-invoice-vat-ue');
		$nip = $self.find('#additional-invoice-nip');
		$idNumber = $self.find('#additional-invoice-id-number');
		$numberIdCountryCode = $self.find('#additional-invoice-number-id-country-code');
		$vatUeCountryCode = $self.find('#additional-invoice-vat-ue-country-code');
		$companyName = $self.find('#additional-invoice-company-name-textarea');
		$employeeName = $self.find('#additional-invoice-employee-name');
		$employeeAddressDetailsToggle = $self.find('#employee-address-details-toggle');
		$taxIdentifierSelector = $self.find('#additional-invoice-tax-identifier-selector');
		$internalId = $self.find('#additional-invoice-internal-id');
		$roleSelector = $self.find('#additional-invoice-role');
		$countryCode = $self.find('#additional-invoice-country-code');
		$invoiceAddress = $self.find('.invoice-address-box').find('input:not(#invoice-flat-number), textarea');
		$zipCode = $self.find('#additional-invoice-zip-code');
		$roleDescription = $self.find('#additional-invoice-role-description');
		$percentageShare = $self.find('#additional-invoice-percentage-share');
		$additionalInvoiceEmail = $self.find('#additional-invoice-email');
		$additionalEntityFormTitle = $deliveryForm.find('#additional-invoice-form-title');
		$additionalEntityAddressTitle = $self.find('#additional-invoice-address-title');
		$additionalInvoiceDataSelector = $self.find('#additional-invoice-data-selector');
		$additionalInvoiceDataInput = $additionalInvoiceDataSelector.find('#additional-invoice-data-input');
	}

	function setEvents($deliveryForm) {
		if (!isOneInit) {
			isOneInit = true;
			broker.on(`DELIVERY_TAX_PAYER_ROLE_CHANGED
					DELIVERY_INVOICE_DATA_CHANGED
					DELIVERY_FRONT_USER_TYPE_CHANGED`, handleTaxPayerRoleAvailability);
			broker.on('DELIVERY_OTHER_INVOICE_RECEIVER_CHANGED', function () {
				handleTaxPayerRoleAvailability();
				handleTaxIdTypeCrossing();
			});
			broker.on('VIES_VERIFICATION_FINISHED', handleViesVerificationFinished);
			broker.on(`DELIVERY_INVOICE_TAX_ID_TYPE_CHANGED
					DELIVERY_BUYER_TAX_ID_TYPE_CHANGED`, handleTaxIdTypeCrossing);
		}

		$additionalInvoiceDataInput.on('change', function () {
			const index = $(this).val();
			const savedInvoiceData = config.additionalInvoiceAddresses[index];
			fillEntityInvoiceData(savedInvoiceData);
		});

		$vatUeCountryCode.on('change', function () {
			validate.element($vatUe, $deliveryForm);
		});

		$employeeAddressDetailsToggle.on('click', function handleEmployeeAddressDetailsToggle() {
			employeeAddressRequired = $(this).is(':checked');
			render();
		});

		$toggleAdditionalEntityDetails.on('click', function handleEntityDetailsClick() {
			config.deliveryInfo.showAdditionalInvoice = $(this).is(':checked');
			render();
		});

		$taxIdentifierSelector.on('change', function () {
			additionalTaxIdType = $(this).val();
			validate.element($(this), $deliveryForm);
			onTaxIdentifierChange();
		});

		$roleSelector.on('change', function handleRoleChange() {

			role = $(this).val();

			if (role === 'EMPLOYEE') {
				additionalTaxIdType = 'EMPTY_ID';
				select.setValue({ $input: $taxIdentifierSelector, value: additionalTaxIdType });
			}

			setAdditionalTaxIdTypeOnFiscalMismatch();
			render();
		});

		$numberIdCountryCode.on('change', function () {
			validate.element($(this), $deliveryForm);
		});

		$countryCode.on('change', () => {
			validate.element($countryCode, $deliveryForm);
			if ($zipCode.val().length) {
				validate.element($zipCode, $deliveryForm);
			}

			setAutocomplete();

			const countryCode = $countryCode.val();

			setZipCode(countryCode);

			if (hasChangedPolishCountryCode($countryCode)) {
				emptyAddressData(); // czyścimy dane adresowe
			}

			$countryCode.data('prev-value', countryCode);
		});

		setAutocomplete();

		companyName.init('additional-invoice-company-name');

		$('#additional-invoice-id-number-div').on('input', function () {
			$idNumber.val($(this).text());
			validate.element($idNumber, $deliveryForm);
		});

		regon.init({
			$country: $countryCode,
			$box: $self.find('.regon-box'),
			$nip: $('#additional-invoice-nip'),
			$companyName: $('#additional-invoice-company-name-textarea-div'),
			$city: $('#additional-invoice-city-name'),
			$street: $('#additional-invoice-street'),
			$houseNumber: $('#additional-invoice-house-number'),
			$flatNumber: $('#additional-invoice-flat-number'),
			$zipCode: $zipCode
		});

		let $viesButton = $self.find('.js-vies-button');

		vies.init({
			$box: $self.find('.vies-box'),
			$button: $viesButton,
			$vatNumber: $vatUe,
			$country: $vatUeCountryCode,
			$taxIdSelector: $taxIdentifierSelector,
			nipEuValidate: config.nipEuValidate,
			validatedVatUeNumbers: config.validatedVatUeNumbers,
			onVatUeValidationUpdated: triggerVatUeValidation
		});

		// wymuszamy weryfikację VIES dla klienta powracającego
		if ($viesButton.length && !$viesButton.is(':disabled')) {
			triggerVatUeValidation();
			validate.scrollToError();
		}

		function handleViesVerificationFinished(event, result) {
			if (result.success) {
				updateValidatedVatUeNumbersConfig(result.countryCode, result.vatUeNumber);
			}
			triggerVatUeValidation();
		}

		function updateValidatedVatUeNumbersConfig(countryCode, vatUeNumber) {
			if (!config.validatedVatUeNumbers.some(entry => entry[countryCode] && entry[countryCode].includes(vatUeNumber))) {
				config.validatedVatUeNumbers.push({ [countryCode]: [vatUeNumber] });
			}
		}

		function triggerVatUeValidation() {
			validate.element($vatUeCountryCode, $deliveryForm);
			validate.element($vatUe, $deliveryForm);
		}
	}

	function handleTaxPayerRoleAvailability() {

		const isTaxPayerRoleAvailable = config.deliveryInfo.frontUserType === 'COMPANY' && config.deliveryInfo.invoiceNeeded;
		const isTaxPayerRoleSelected = isTaxPayerRoleAvailable && (config.deliveryInfo.taxPayerRoleJst || config.deliveryInfo.taxPayerRoleGrv);

		role = !isTaxPayerRoleSelected ? 'RECIPIENT' : config.deliveryInfo.taxPayerRoleJst ? 'JST_RECIPIENT' : 'VAT_GROUP_MEMBER_RECIPIENT';
		additionalTaxIdType = 'NIP';

		config.deliveryInfo.showAdditionalInvoice = isTaxPayerRoleSelected;

		$roleSelector.closest('.row-select').toggleClass('row-select-disabled', isTaxPayerRoleSelected);
		select.toggleActive($roleSelector, !isTaxPayerRoleSelected);
		select.setValue({ $input: $roleSelector, value: role });
		select.setValue({ $input: $taxIdentifierSelector, value: additionalTaxIdType });

		emptyAddressData();
		$nip.val('');
		$companyName.prev().text('');

		render();
	}

	function handleTaxIdTypeCrossing() {

		setAdditionalTaxIdTypeOnFiscalMismatch();
		render();
	}

	// Reguły poprawności identyfikatorów podatkowych dla Dodatkowego Podmiotu:
	// - Identyfikatory niefiskalne: NIP, VAT_UE, INTERNAL_ID
	// - Identyfikatory fiskalne: NUMBER_ID, EMPTY_ID
	// - Krzyżowanie fiskalnych z niefiskalnymi zabronione tylko dla roli 'ADDITIONAL_BUYER' (Dodatkowy Nabywca)
	// - W innych rolach Dodatkowego Podmiotu krzyżowanie dozwolone
	function setAdditionalTaxIdTypeOnFiscalMismatch() {

		if (role === 'ADDITIONAL_BUYER') {

			const taxIdType = config.deliveryInfo.invoiceNeeded ? config.deliveryInfo.invoiceTaxIdType : config.deliveryInfo.taxIdType;

			if ((taxIdType === 'NIP' || taxIdType === 'VAT_UE') && (additionalTaxIdType === 'NUMBER_ID' || additionalTaxIdType === 'EMPTY_ID')) {
				additionalTaxIdType = 'NIP';
				emptyDataOnFiscalMismatch();
			}

			if ((taxIdType === 'NUMBER_ID' || taxIdType === 'EMPTY_ID') && (additionalTaxIdType === 'NIP' || additionalTaxIdType === 'VAT_UE' || additionalTaxIdType === 'INTERNAL_ID')) {
				if (config.deliveryInfo.isPolishAddressRequired) {
					additionalTaxIdType = 'EMPTY_ID';
				} else {
					additionalTaxIdType = 'NUMBER_ID';
				}
				emptyDataOnFiscalMismatch();
			}
			select.setValue({ $input: $taxIdentifierSelector, value: additionalTaxIdType });
		}
	}

	function emptyDataOnFiscalMismatch() {
		$companyName.prev().text('');
		$additionalInvoiceEmail.val('');
		$percentageShare.val('');
		emptyAddressData();
	}

	function emptyAddressData() {

		if (config.additionalInvoiceAddresses) { // ustawiamy selektor na "nowe dane"
			select.setValue({ $input: $additionalInvoiceDataInput, value: '0' });
		}

		$('#additional-invoice-street, #additional-invoice-house-number, #additional-invoice-flat-number, #additional-invoice-zip-code, #additional-invoice-city-name').val('');
	}

	function setZipCode(countryCode) {

		const isPolishCountryCode = countryCode === 'PL';
		const maxLength = isPolishCountryCode ? 6 : 8;
		const type = isPolishCountryCode ? 'tel' : 'text';
		const placeholder = isPolishCountryCode ? '_ _ - _ _ _' : '';

		$zipCode.filter(':not([type=hidden])').prop({
			'maxlength': maxLength,
			'type': type,
			'placeholder': placeholder
		});
	}

	function hasChangedPolishCountryCode($countryCode) {
		const previousValue = $countryCode.data('prev-value');
		const currentValue = $countryCode.val();

		if (previousValue === 'PL' && currentValue !== 'PL') {
			return true;
		}

		return previousValue !== 'PL' && currentValue === 'PL';
	}

	function onTaxIdentifierChange() {

		if (!config.deliveryInfo.isPolishAddressRequired) {
			select.clear($numberIdCountryCode);
			select.clear($vatUeCountryCode);
		}

		render();
	}

	function getViewState() {
		const showAdditionalInvoice = config.deliveryInfo.showInvoiceData && config.deliveryInfo.showAdditionalInvoice;
		const isEmployeeRole = role === 'EMPLOYEE';
		const isTaxPayerRoleAvailable = config.deliveryInfo.frontUserType === 'COMPANY' && config.deliveryInfo.invoiceNeeded;
		const isTaxPayerRoleSelected = isTaxPayerRoleAvailable && (config.deliveryInfo.taxPayerRoleJst || config.deliveryInfo.taxPayerRoleGrv);
		const isAdditionalBuyerRole = role === 'ADDITIONAL_BUYER';

		return {
			// --- widoczność sekcji
			showAdditionalInvoice: showAdditionalInvoice,
			employeeAddressRequired: employeeAddressRequired,
			hideAdditionalInvoiceEntityControls: config.deliveryInfo.frontUserType === 'INDIVIDUAL' || isTaxPayerRoleSelected,
			hideAdditionalInvoiceDetails: !showAdditionalInvoice,
			hideAdditionalInvoicePercentageShare: !showAdditionalInvoice || !isAdditionalBuyerRole,
			hideAdditionalInvoiceRoleDescription: !showAdditionalInvoice || role !== 'OTHER_ROLE',
			hideAdditionalInvoiceEmail: !showAdditionalInvoice || !isAdditionalBuyerRole,
			hideInvoiceEntityRestrictionsMessage: !isAdditionalBuyerRole,
			isTaxIdentifierSelectorActive: !isEmployeeRole,
			isEmployeeRoleSelected: isEmployeeRole,
			isInvoiceAddressBoxHidden: isEmployeeRole && !employeeAddressRequired,
			additionalEntityFormTitle: getAdditionalEntityFormTitle(),
			additionalEntityAddressTitle: getAdditionalEntityAddressTitle(),

			// --- stan pól (do walidacji)
			disableInvoiceAddress: isEmployeeRole && !employeeAddressRequired,
			disablePercentageShare: !isAdditionalBuyerRole,
			disableAdditionalInvoiceEmail: !isAdditionalBuyerRole,
			disableRoleDescription: role !== 'OTHER_ROLE',
			disableTaxIdentifierSelector: false,
			disableNip: additionalTaxIdType !== 'NIP',
			disableVatUe: additionalTaxIdType !== 'VAT_UE',
			disableVatUeCountryCode: additionalTaxIdType !== 'VAT_UE',
			disableIdNumber: additionalTaxIdType !== 'NUMBER_ID',
			disableNumberIdCountryCode: additionalTaxIdType !== 'NUMBER_ID',
			disableInternalId: additionalTaxIdType !== 'INTERNAL_ID',
			disableCompanyName: isEmployeeRole,
			disableEmployeeName: !isEmployeeRole,
		};
	}

	function render() {

		const state = getViewState();

		setTaxIdTypeBox();
		select.toggleActive($taxIdentifierSelector, state.isTaxIdentifierSelectorActive);

		$toggleAdditionalEntityDetails.prop('checked', state.showAdditionalInvoice);
		$employeeAddressDetailsToggle.prop('checked', state.employeeAddressRequired);

		// Ogólne klasy widoczności sekcji Dodatkowego Podmiotu
		orderClass.toggle('hide-additional-invoice-entity-controls', state.hideAdditionalInvoiceEntityControls);
		orderClass.toggle('hide-additional-invoice-details', state.hideAdditionalInvoiceDetails);
		orderClass.toggle('hide-invoice-entity-restrictions-message', state.hideInvoiceEntityRestrictionsMessage);

		// Klasy związane z komponentami Dodatkowego Podmiotu
		$self.toggleClass('employee-role-selected', state.isEmployeeRoleSelected);
		$self.toggleClass('hide-additional-invoice-address', state.isInvoiceAddressBoxHidden);
		$self.toggleClass('hide-additional-invoice-percentage-share', state.hideAdditionalInvoicePercentageShare);
		$self.toggleClass('hide-additional-invoice-role-description', state.hideAdditionalInvoiceRoleDescription);
		$self.toggleClass('hide-additional-invoice-email', state.hideAdditionalInvoiceEmail);

		$additionalEntityFormTitle.text(state.additionalEntityFormTitle);
		$additionalEntityAddressTitle.text(state.additionalEntityAddressTitle);
		updateAvailableTaxIdTypes();
		updateAvailableEntityInvoices();

		updateValidation(state);

		// czyścimy błędy z backendu
		$('input[name^=additionalInvoice]').each(function () {
			validate.removeBackendError($(this));
		});
	}

	function getAdditionalEntityFormTitle() {
		if (role === 'JST_RECIPIENT') {
			return config.deliveryInfo.sectionTitle.additionalEntityForm.jst;
		}
		if (role === 'VAT_GROUP_MEMBER_RECIPIENT') {
			return config.deliveryInfo.sectionTitle.additionalEntityForm.grv;
		}
		return config.deliveryInfo.sectionTitle.additionalEntityForm.default;
	}

	function getAdditionalEntityAddressTitle() {
		if (role === 'JST_RECIPIENT') {
			return config.deliveryInfo.sectionTitle.additionalEntityAddress.jst;
		}
		if (role === 'VAT_GROUP_MEMBER_RECIPIENT') {
			return config.deliveryInfo.sectionTitle.additionalEntityAddress.grv;
		}
		return config.deliveryInfo.sectionTitle.additionalEntityAddress.default;
	}

	// Reguły widoczności identyfikatorów podatkowych dla Dodatkowego Podmiotu:
	// - Identyfikatory niefiskalne: NIP, VAT_UE, INTERNAL_ID
	// - Identyfikatory fiskalne: NUMBER_ID, EMPTY_ID
	// - Krzyżowanie fiskalnych z niefiskalnymi zabronione tylko dla roli 'ADDITIONAL_BUYER' (Dodatkowy Nabywca)
	// - W innych rolach Dodatkowego Podmiotu krzyżowanie dozwolone
	function updateAvailableTaxIdTypes() {

		if (role === 'ADDITIONAL_BUYER') {
			const taxIdType = config.deliveryInfo.invoiceNeeded
				? config.deliveryInfo.invoiceTaxIdType
				: config.deliveryInfo.taxIdType;

			if (taxIdType === 'NIP' || taxIdType === 'VAT_UE') {
				select.showOptions($taxIdentifierSelector, '[data-value=NIP], [data-value=VAT_UE], [data-value=INTERNAL_ID]');
			} else if (taxIdType === 'NUMBER_ID' || taxIdType === 'EMPTY_ID') {
				select.showOptions($taxIdentifierSelector, '[data-value=NUMBER_ID], [data-value=EMPTY_ID]');
			}
		} else if (role === 'JST_RECIPIENT' || role === 'VAT_GROUP_MEMBER_RECIPIENT') {
			select.showOptions($taxIdentifierSelector, '[data-value=NIP], [data-value=INTERNAL_ID]');
		} else {
			select.showOptions($taxIdentifierSelector, '[data-value]');
		}
	}

	function updateAvailableEntityInvoices() {

		if (config.additionalInvoiceAddresses) {
			const availableEntityInvoices = calculateAvailableEntityInvoices();
			select.showOptions($additionalInvoiceDataInput, availableEntityInvoices);
		}

		const containsAnyVisibleOption = $additionalInvoiceDataInput.parent().find('.js-customic-select-option:not(.customic-select-option-hidden)').length > 1;
		$additionalInvoiceDataSelector.toggleClass('is-hidden', !containsAnyVisibleOption);
	}

	function calculateAvailableEntityInvoices() {

		return config.additionalInvoiceAddresses
			.filter(isInvoiceMatchingTaxIdType)
			.filter(isInvoiceMatchingRole)
			.map(invoice => `[data-id=${invoice.id}]`)
			.concat('[data-value=0]') // opcja "nowe dane" zawsze widoczna
			.join(', ');
	}

	function isInvoiceMatchingTaxIdType(invoice) {

		if (invoice.role === 'ADDITIONAL_BUYER' || role === 'ADDITIONAL_BUYER') {

			const taxIdType = config.deliveryInfo.invoiceNeeded
				? config.deliveryInfo.invoiceTaxIdType
				: config.deliveryInfo.taxIdType;

			if (taxIdType === 'NIP' || taxIdType === 'VAT_UE') {
				return ['NIP', 'VAT_UE', 'INTERNAL_ID'].includes(invoice.companyTaxIdType);
			}

			if (taxIdType === 'NUMBER_ID' || taxIdType === 'EMPTY_ID') {
				return ['NUMBER_ID', 'EMPTY_ID'].includes(invoice.companyTaxIdType);
			}
		}

		return true;
	}

	function isInvoiceMatchingRole(invoice) {

		if (role === 'JST_RECIPIENT' || role === 'VAT_GROUP_MEMBER_RECIPIENT') {
			return invoice.role === role;
		}
		return invoice.role !== 'JST_RECIPIENT' && invoice.role !== 'VAT_GROUP_MEMBER_RECIPIENT';
	}

	function setFieldState($field, shouldBeIgnored) {
		if ($field.hasClass('ignore') !== shouldBeIgnored) {
			$field.ignore(shouldBeIgnored);
		}
	}

	function disableAllFieldsValidation() {
		[
			$invoiceAddress,
			$idNumber,
			$vatUe,
			$nip,
			$vatUeCountryCode,
			$numberIdCountryCode,
			$companyName,
			$internalId,
			$roleDescription,
			$percentageShare,
			$taxIdentifierSelector,
			$employeeName,
			$additionalInvoiceEmail
		].forEach($field => setFieldState($field, true));
	}

	function enableFieldsValidation(state) {

		setFieldState($invoiceAddress, state.disableInvoiceAddress);
		setFieldState($percentageShare, state.disablePercentageShare);
		setFieldState($additionalInvoiceEmail, state.disableAdditionalInvoiceEmail);
		setFieldState($roleDescription, state.disableRoleDescription);
		setFieldState($taxIdentifierSelector, state.disableTaxIdentifierSelector);
		setFieldState($nip, state.disableNip);
		setFieldState($vatUe, state.disableVatUe);
		setFieldState($vatUeCountryCode, state.disableVatUeCountryCode);
		setFieldState($idNumber, state.disableIdNumber);
		setFieldState($numberIdCountryCode, state.disableNumberIdCountryCode);
		setFieldState($internalId, state.disableInternalId);
		setFieldState($companyName, state.disableCompanyName);
		setFieldState($employeeName, state.disableEmployeeName);
	}

	function updateValidation(state) {

		$vatUeCountryCode.prop('disabled', additionalTaxIdType !== 'VAT_UE');
		$numberIdCountryCode.prop('disabled', additionalTaxIdType !== 'NUMBER_ID');

		if (!state.showAdditionalInvoice) {
			disableAllFieldsValidation();
			return;
		}

		enableFieldsValidation(state);
	}

	function setTaxIdTypeBox() {
		$taxIdTypeBoxes
			.removeClass('active')
			.filter((i, el) => el.dataset.type === additionalTaxIdType)
			.addClass('active');
	}

	function setAutocomplete() {
		if ($countryCode.val() === "PL") {
			$.cityAutocomplete('#additional-invoice-zip-code', '#additional-invoice-city-name', config.streetValidateEnable ? '#additional-invoice-street' : false);
		} else {
			$.cityUnautocomplete('#additional-invoice-zip-code', '#additional-invoice-city-name', '#additional-invoice-street');
		}
	}

	function fillEntityInvoiceData(savedInvoiceData) {
		$('#additional-invoice-street').val(savedInvoiceData.street);
		$('#additional-invoice-house-number').val(savedInvoiceData.houseNumber);
		$('#additional-invoice-flat-number').val(savedInvoiceData.flatNumber);
		$('#additional-invoice-city-name').val(savedInvoiceData.city);
		$('#additional-invoice-employee-name').val(savedInvoiceData.employeeName);
		$('#additional-invoice-company-name-textarea-div').text(savedInvoiceData.companyName).trigger('input');
		$('#additional-invoice-id-number-div').text(savedInvoiceData.numberId).trigger('input');

		$self.find('.vies-box').removeClass('is-success');
		$self.find('.js-vies-button').prop('disabled', true);

		$zipCode.val(savedInvoiceData.zipCode);
		$nip.val(savedInvoiceData.nip);
		$vatUe.val(savedInvoiceData.vatUe);
		$internalId.val(savedInvoiceData.internalId)

		additionalTaxIdType = savedInvoiceData.companyTaxIdType !== "" ? savedInvoiceData.companyTaxIdType : "NIP";
		if (role !== 'JST_RECIPIENT' && role !== 'VAT_GROUP_MEMBER_RECIPIENT') {
			role = savedInvoiceData.role || "RECIPIENT";
		}
		if (role === 'EMPLOYEE') {
			employeeAddressRequired = savedInvoiceData.employeeAddressRequired;
		}
		const countryCode = savedInvoiceData.countryCode || "PL";

		select.setValue({ $input: $taxIdentifierSelector, value: additionalTaxIdType });
		select.setValue({ $input: $countryCode, value: countryCode });
		$countryCode.data('prev-value', countryCode);
		select.setValue({ $input: $roleSelector, value: role })
		setZipCode(countryCode);

		if (additionalTaxIdType === 'VAT_UE' && savedInvoiceData.companyCountryCode) {
			select.setValue({ $input: $vatUeCountryCode, value: savedInvoiceData.companyCountryCode });
			$vatUe.trigger('input');
		}

		if (additionalTaxIdType === 'NUMBER_ID' && savedInvoiceData.companyCountryCode) {
			select.setValue({ $input: $numberIdCountryCode, value: savedInvoiceData.companyCountryCode });
		}

		render();
	}

	return {
		init,
		render
	};
});
